import { ResolveOperations } from '@/constants/disputes/ResolveOperations'
import CommentModel from '@/models/comments/commentModel'
import CommentType from '@/constants/comments/CommentType'
import dayjs from '@/services/date'
import DateFormatToken from '@/constants/date/DateFormatToken'
import DisputeTimesheetDetailsClient from '@/models/disputes/disputeTimesheetDetailsClient'
import DisputeTimesheetDetailsCandidateCommentModel from '@/models/disputes/disputeTimesheetDetailsCandidateCommentModel'
import DisputeTimesheetDetailsTimeEntryCommentModel from '@/models/disputes/disputeTimesheetDetailsTimeEntryCommentModel'
import DisputeHistoryOriginalBookingTimesCommentModel from '@/models/comments/disputeHistoryOriginalBookingTimesCommentModel'

const { HHmmss, HHmm } = DateFormatToken

const {
  CustomDisputeResolutionHistoryCandidate,
  CustomDisputeResolutionHistoryClient,
  CustomDisputeResolutionHistoryOriginal,
  CustomDisputeResolutionHistoryCandidateTimeEntry,
} = CommentType

const mapToCommentProperties = (addedBy, date, type, model) => ({
  addedBy,
  dateCreated: dayjs.isDayjs(date) ? date : dayjs(date),
  commentText: JSON.stringify(model),
  type,
})

export default class DisputeHistoryCommentFactory {
  constructor(timesheet, priorityTimesheetType) {
    this.timesheet = timesheet
    this.priorityTimesheetType = priorityTimesheetType
  }

  createComment(submissionType) {
    const commentData = this.buildCommentData(submissionType)

    const comment = new CommentModel({
      id: submissionType,
      ...commentData,
    })

    comment.isPriorityTimesheet = this.priorityTimesheetType === submissionType

    return comment
  }

  buildCommentData(submissionType) {
    const {
      candidateTimesheet,
      clientTimesheet,
      candidateTimeEntries,
      startTime,
      endTime,
      breakMinutes,
      candidate,
      shouldShowRestBreaksQuestion,
      location,
      startDate,
    } = this.timesheet

    switch (submissionType) {
      case ResolveOperations.CANDIDATE:
        return mapToCommentProperties(
          candidate.name,
          candidateTimesheet.submittedDateUtc,
          CustomDisputeResolutionHistoryCandidate,
          new DisputeTimesheetDetailsCandidateCommentModel({
            ...candidateTimesheet,
            shouldShowRestBreaksQuestion,
          })
        )

      case ResolveOperations.CLIENT:
        return mapToCommentProperties(
          clientTimesheet.details.contactName,
          clientTimesheet.submittedDateUtc,
          CustomDisputeResolutionHistoryClient,
          new DisputeTimesheetDetailsClient(clientTimesheet)
        )

      case ResolveOperations.ORIGINAL:
        return mapToCommentProperties(
          'Relief Roster',
          dayjs.tz(startDate, location.timeZone).utc(),
          CustomDisputeResolutionHistoryOriginal,
          new DisputeHistoryOriginalBookingTimesCommentModel({
            startTime,
            endTime,
            breakMinutes,
          })
        )

      case ResolveOperations.TIME_ENTRY:
        return mapToCommentProperties(
          candidate.name,
          candidateTimeEntries.firstInteractionDateUtc,
          CustomDisputeResolutionHistoryCandidateTimeEntry,
          new DisputeTimesheetDetailsTimeEntryCommentModel({
            ...candidateTimeEntries,
            bookingStartTime: dayjs(startTime, HHmmss).format(HHmm),
            bookingEndTime: dayjs(endTime, HHmmss).format(HHmm),
            bookingMealBreakMinutes: breakMinutes,
          })
        )

      default:
        throw new Error(`Invalid submission type: ${submissionType}.`)
    }
  }
}
